import localStorage from './localStorage';

/**
 * gotoManagement
 *  跳转至应用的管理页面
 *  @param {string} dataType - 跳转应用的dataType，默认为当前页面的dataType，当跳转至其他模块时，需手动传入目标模块的dataType （eg. task-management）
 *  @param {object} appInfo - 应用相关信息，默认为当前应用的信息，当跳转至其他模块的应用时，需传入目标应用的应用信息，
 *  包括 moduleId, appId, instanceConfig, name, moduleControlType等
 *  （eg. {moduleId: 13000, appId: 144332, name: '任务管理', instanceConfig: '', moduleControlType: 'org_control'}）
 *  @param {string} subRoute - 跳转的子路由，不传则跳转至管理页面的首页（eg. /workflow）
 **/
const gotoManagement = (dataType, appInfo, subRoute = '') => {
	// 判断当前页面是否在管理页面
	const inManagement = window.location.pathname.includes('/system.html');
	if (!dataType) {
		const pathname = window.location.hash.substring(1).split(/[?#&]/)[0];
		dataType = inManagement ? pathname.split('/')[2] : pathname.split('/')[1];
	}
	if (!appInfo || Object.prototype.toString.call(appInfo) !== '[object Object]' || !Reflect.ownKeys(appInfo).length) {
		const { moduleId, appId, instanceConfig, name, moduleControlType } = window.$$context;
		appInfo = { moduleId, appId, instanceConfig, name, moduleControlType };
	}
	localStorage.write('SysConfigContext', JSON.stringify(appInfo));

	if (subRoute && subRoute.substring(0, 1) !== '/') subRoute = `/${subRoute}`;

	let url = window.location.origin + window.location.pathname;
	if (/\.html$/.test(url)) {
		url = url.replace(/[^/]+\.html$/, 'system.html');
	} else {
		url = url.replace(/\/$/, '/system.html');
	}
	url = url + `#/app-config/${dataType}/management${subRoute}`;
	// 当前在管理页面中，则替换当前页面；否则新开页面
	if (inManagement) {
		window.location.href = url;
	} else {
		window.open(url);
	}
};

export default gotoManagement;
